// extracted by mini-css-extract-plugin
export default {"flexWrap":"Ke9IbdJfLT6TmxHuK3E3","resume":"Ul6vS81g1KGpKTaPaQ7X","leftColumn":"Zd283CJjGBuWGXS4S0gW"};
    if(module.hot) {
      // 1647894309274
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  